import { AbstractPlayableContent, TemporalIndicators } from "./AbstractPlayableContent";

export class RhythmicBloc extends AbstractPlayableContent {
  constructor(blocId: number, blocName: string,  temporalIndicators: TemporalIndicators, baseModel: any) {
    super('bloc', blocId, blocName, temporalIndicators, baseModel, []);
  }
}